export default __webpack_public_path__ + "static/media/galleryImg1.64b2c61b.png";